import DesTeamContentsViewModel from 'viewmodel/DesTeamContentsViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesTeamContents extends DesBaseCatalogAcc {
    constructor() {
        super(DesTeamContentsViewModel);
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid');
    }

    get teamId() {
        return this.getAttribute('teamid') || this.getAttribute('team-id');
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid,
            teamid: this.teamId
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'collaborationspaceid', 'team-id', 'teamid', 'locale'];
    }
}

if (!window.customElements.get('des-team-contents')) {
    window.customElements.define('des-team-contents', DesTeamContents);
}
